/* EVAMATS — strona karty podarunkowej: (1) rabat z koszyka (przekreślona cena, cena po rabacie, „Oszczędzasz −X%”, cena na przycisku),
   (2) wybór rodzaju karty (e-Karta / papierowa), (3) pod każdą kwotą „płacisz X zł”, (4) kwota na podglądzie karty, (5) chipy.
   Ceny pochodzą z tymczasowego koszyka Storefront API, nie z wpisanej na sztywno stawki: rabat bywa 20 i 30%. Bez innerHTML. */
(function () {
  'use strict';
  var API = '/api/2026-04/graphql.json';
  var Q = 'mutation($lines:[CartLineInput!]){cartCreate(input:{lines:$lines}){cart{lines(first:1){nodes{cost{amountPerQuantity{amount} totalAmount{amount}}}}} userErrors{message}}}';
  var me = document.currentScript;
  var ICON = { mail: me && me.getAttribute('data-icon-mail'), parcel: me && me.getAttribute('data-icon-parcel'), bag: me && me.getAttribute('data-icon-bag') };
  var HANDLE = (me && me.getAttribute('data-handle')) || '';
  var IS_ECARD = me && me.getAttribute('data-gift') === 'true';
  var TEST = /-test$/.test(HANDLE);
  var URL_ECARD = '/products/' + (TEST ? 'karta-podarunkowa-nowa-test' : 'e-karta-podarunkowa');
  var URL_PAPER = '/products/' + (TEST ? 'karta-podarunkowa-papierowa-test' : 'karta-podarunkowa-papierowa');
  var cache = {};
  var costVal = {};   // gotowe wyniki: przy przełączeniu kwoty rabat wraca na stronę od razu, bez czekania na sieć
  var noDiscount = {};
  // Szkice (adres shopifypreview.com): produkt jeszcze nie jest publiczny, więc ceny z koszyka nie istnieją, a kafelek rodzaju karty
  // musi prowadzić na podgląd drugiej karty, nie na jej publiczny adres (tam byłoby 404). Po publikacji ten tryb się nie włącza.
  var IN_PREVIEW = /shopifypreview\.com$/.test(location.hostname);
  var PREVIEW = { ecard: '/products_preview?preview_key=fa7e77cd0721deb44ea3b74a3bb684f2', paper: '/products_preview?preview_key=ca65452407645f5cb6f08068ac1a7a2a' };
  // W podglądzie pokazujemy rabat tak, jak będzie na żywo: koszyk żywej STAREJ karty o tej samej kwocie (rabat liczy ta sama reguła sklepu).
  var LIVE_PROXY = { ecard: { '290': '47948500533554', '510': '47948500599090', '550': '47948500566322', '710': '55468403163514', '910': '47948500631858', '1210': '47948500664626' }, paper: { '290': '56600063279482', '510': '56600063312250', '550': '56600063345018', '710': '56600063410554', '910': '56600063377786', '1210': '56600063443322' } };

  function money(n, plain) {
    var s = Number(n).toFixed(2).replace(/\.00$/, '').replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, plain ? ' ' : ' ');
    return s + (plain ? ' zł' : ' zł');
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }
  function variantId() {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : '';
  }
  function nominalOfVariant(id) {
    var map = window.__evmVariantIds || {};
    for (var k in map) { if (String(map[k]) === String(id) && /^\d+\s*zł$/.test(k)) return k.replace(/\D/g, ''); }
    return '';
  }
  function cost(id) {
    var useId = id, endpoint = API;
    if (IN_PREVIEW) {
      useId = (IS_ECARD ? LIVE_PROXY.ecard : LIVE_PROXY.paper)[nominalOfVariant(id)];
      if (!useId) return Promise.resolve(null);
      endpoint = 'https://ivamats.com' + API;
    }
    if (!cache[id]) {
      cache[id] = fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ query: Q, variables: { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + useId, quantity: 1 }] } })
      }).then(function (r) { return r.json(); }).then(function (j) {
        var node = j && j.data && j.data.cartCreate && j.data.cartCreate.cart && j.data.cartCreate.cart.lines.nodes[0];
        if (!node) return null;
        return { before: Number(node.cost.amountPerQuantity.amount), after: Number(node.cost.totalAmount.amount) };
      }).catch(function () { return null; });
    }
    return cache[id];
  }

  /* ---------- cena w karcie tytułowej ---------- */
  function clear(root) {
    root.querySelectorAll('.evm-gp-old, .evm-gp-save').forEach(function (e) { e.remove(); });
  }
  function apply(c) {
    var root = document.querySelector('[id^="price-template"]');
    if (!root) return;
    var reg = root.querySelector('.price__regular .price-item--regular');
    var btn = document.querySelector('.product-form__submit .button_price');
    if (document.querySelector('.dmixer-original-price')) { clear(root); return; }   // rabat pokazuje już aplikacja
    if (!reg || !c || !(c.after < c.before - 0.004)) { clear(root); noDiscount[variantId()] = true; return; }
    if (root.querySelector('.evm-gp-old') && reg.getAttribute('data-evm-gp') === String(c.after)) return;
    clear(root);
    var old = el('span', 'evm-gp-old', money(c.before));
    reg.parentNode.insertBefore(old, reg);
    reg.textContent = money(c.after);
    reg.setAttribute('data-evm-gp', String(c.after));
    var save = el('span', 'evm-gp-save', 'Oszczędzasz −' + Math.round(100 * (c.before - c.after) / c.before) + '%');
    reg.parentNode.insertBefore(save, reg.nextSibling);
    if (btn) btn.textContent = money(c.after, true);
  }

  /* ---------- układ strony ---------- */
  function nominal(label) {
    var m = String(label.firstChild ? label.firstChild.textContent : label.textContent).replace(/\s/g, '').match(/(\d+)/);
    return m ? Number(m[1]) : 0;
  }
  function build() {
    var vr = document.querySelector('variant-radios');
    if (!vr) return;
    var info = vr.parentNode;
    // theme: stary wybór „Typ karty” (u karty papierowej jedna opcja) zastępuje nasz kafelek
    vr.querySelectorAll('fieldset').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (lg && /^\s*Typ karty\s*$/i.test(lg.textContent)) fs.style.display = 'none';
    });
    var form = document.querySelector('product-form');
    if (form && form.parentElement) form.parentElement.classList.add('evm-gp-formwr');
    if (!info.querySelector('.evm-gp-type')) {
      var type = el('div', 'evm-gp-type');
      type.appendChild(el('p', 'evm-gp-type__title', 'Wybierz rodzaj karty'));
      var grid = el('div', 'evm-gp-type__grid');
      [['e-Karta', 'Kod prosto na e-mail', IN_PREVIEW ? PREVIEW.ecard : URL_ECARD, IS_ECARD], ['Papierowa +20 zł', 'Wysyłamy pocztą', IN_PREVIEW ? PREVIEW.paper : URL_PAPER, !IS_ECARD]].forEach(function (t) {
        var a = el('a', 'evm-gp-type__tile' + (t[3] ? ' is-active' : ''));
        a.href = t[2];
        if (t[3]) a.setAttribute('aria-current', 'true');
        a.appendChild(document.createTextNode(t[0]));
        a.appendChild(el('small', '', t[1]));
        grid.appendChild(a);
      });
      type.appendChild(grid);
      info.insertBefore(type, vr);
    }
    if (!info.querySelector('.evm-gp-chips')) {
      var chips = el('div', 'evm-gp-chips');
      (IS_ECARD ? [['Kod prosto na e-mail', ICON.mail], ['Płacisz nią w całym sklepie', ICON.bag]] : [['Wysyłamy pod wskazany adres', ICON.parcel], ['Płacisz nią w całym sklepie', ICON.bag]]).forEach(function (t) {
        var chip = el('div', 'evm-gp-chip');
        if (t[1]) { var img = el('img', 'evm-gp-chip__img'); img.src = t[1]; img.alt = ''; img.width = 44; img.height = 44; img.decoding = 'async'; chip.appendChild(img); } else chip.classList.add('evm-gp-chip--dot');
        chip.appendChild(el('span', 'evm-gp-chip__txt', t[0]));
        chips.appendChild(chip);
      });
      var priceRow = document.querySelector('.main_price');
      info.insertBefore(chips, priceRow ? priceRow.nextSibling : info.firstChild);
    }
  }

  /* ---------- „płacisz X zł” pod kwotami ---------- */
  function subs() {
    document.querySelectorAll('variant-radios fieldset input[type=radio]').forEach(function (input) {
      var fs = input.closest('fieldset');
      if (fs && fs.style.display === 'none') return;   // ukryty wybór „Typ karty”
      var label = input.nextElementSibling;
      if (!label || label.tagName !== 'LABEL' || label.querySelector('.evm-gp-sub')) return;
      var vid = input.getAttribute('data-variant-id') || (window.__evmVariantIds && window.__evmVariantIds[input.value]);
      if (!vid) return;
      cost(vid).then(function (c) {
        if (!c || label.querySelector('.evm-gp-sub')) return;
        costVal[vid] = c;
        var nom = nominal(label);
        if (Math.abs(c.after - nom) < 0.004) return;
        var s = el('span', 'evm-gp-sub');
        s.appendChild(document.createTextNode('płacisz '));
        s.appendChild(el('b', '', money(c.after)));
        label.appendChild(s);
      });
    });
  }
  function readVariantIds() {
    var map = {};
    var script = document.querySelector('variant-radios script[type="application/json"]');
    if (!script) return;
    try {
      JSON.parse(script.textContent).forEach(function (v) { map[(v.option2 || v.option1 || v.title)] = v.id; if (v.option1) map[v.option1] = v.id; });
    } catch (e) { return; }
    window.__evmVariantIds = map;
  }

  var last = '';
  function tick() {
    build();
    subs();
    var id = variantId();
    if (!id) return;
    var root = document.querySelector('[id^="price-template"]');
    var shown = root && root.querySelector('.evm-gp-old');
    if (id === last && (shown || noDiscount[id])) return;
    last = id;
    if (costVal[id] !== undefined) { apply(costVal[id]); return; }
    cost(id).then(function (c) { costVal[id] = c; if (variantId() === id) apply(c); });
  }

  // Motyw po zmianie kwoty na chwilę podmienia blok ceny na gołą cenę; obserwujemy to i przywracamy rabat w tej samej klatce (bez skoku układu).
  var raf = 0;
  function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; last = ''; tick(); }); }
  function watch() {
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) new MutationObserver(schedule).observe(info, { childList: true, subtree: true, characterData: true });
  }

  function start() { readVariantIds(); tick(); watch(); setInterval(tick, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
